import { Injectable } from '@angular/core';
import { BehaviorSubject , Observable, Subject } from 'rxjs';
import { ApiConstants } from '../../../core/endpointsAndGeneric-constants/api-constants';
import { HttpMethodModifierService } from '../../../core/http-method-modifier.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private toggleState = new BehaviorSubject<[string,boolean]>(['', true]);
  public toggleState$ = this.toggleState.asObservable();
  private toggle = new BehaviorSubject('');

  constructor(
        private httpGuard:HttpMethodModifierService
  ){}

  logout(userName: string) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT_V1', ApiConstants.URL.logout, { userName });
  }

  public setToggleButtonClick(title:string) {
    this.toggle.next(title);
  }
    
  public getToggleButtonClick(): Observable<string> {
    return this.toggle.asObservable();
  }
}
